const getIfr = () => {
  const ifr = document.getElementById('iframe_360');
  return ifr ? (ifr.window || ifr.contentWindow) : window;
}
const app = {
  nowOuterCode: '',
  nowInterCode: '',
  carType: undefined,
  highlights:true,

  changeCarConfiguration: function (code, run) {
    app.carType = code
    try {
      if (run) {
        getIfr().changeCarConfiguration({
          nextType: code,
        })
      }
    } catch (e) {
      console.log('changeCarConfiguration', e)
    }
  },
  //进入外观
  back_to_origin: function () {
    try {
      getIfr().SetCameraOut(getIfr().appInstance)
    } catch (e) {
    }
  },
  //进入内室
  goto_paraPos: function () {
    try {
      getIfr().SetCameraInner(getIfr().appInstance)
    } catch (e) {
    }
  },
  addBoutique(id) {
    try {
      getIfr().addBoutique(id);
    } catch (e) {
      console.log('addBoutique', id)
    }
  },
  accBoutique(id) {
    try {
      getIfr().accBoutique(id);
    } catch (e) {
      console.log('accBoutique', id)
    }
  },
  toggleInteractiveIcon(){
    getIfr().toggleInteractiveIcon()
  },
  //显示内室热点
  showInteriorPoints: function () {
    getIfr().toggleInteractiveIcon()
  },
  //隐藏内室热点
  hideInteriorPoints: function () {
    getIfr().toggleInteractiveIcon()
  },
  //显示外观热点
  show_chu_dom: function () {
    getIfr().toggleInteractiveIcon()
  },
  //隐藏外观热点
  hide_chu_dom: function () {
    getIfr().toggleInteractiveIcon()
  },
  //行车动画
  back_carRunPlay: function () {
    getIfr().playCarAnimation('Armature', false);
  },
  //停车_pc
  back_carRunStop_pc: function () {
    getIfr().playCarAnimation('Armature', true);
  },
  //停车_手机
  back_carRunStop_mob: function () {
    getIfr().playCarAnimation('Armature', true);
  },
  //切换内饰颜色和车型
  changeInterior: function (color, run) {
    try {
      if (run) {
        getIfr()?.changeCarInner?.(app.nowInterCode, color);
      }
    } catch (e) {
    }
    app.nowInterCode = color
  },
  changeOutward: function (code, run) {
    try {
      if (getIfr().changeCarOut && run) {
        getIfr().changeCarOut(app.nowOuterCode, code || app.nowOuterCode);
      }
    } catch (e) {
    }
    app.nowOuterCode = code
  }
}

export default app
